import Vue from "vue";
import IdleVue from "idle-vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";

import PortalVue from "portal-vue";
Vue.use(PortalVue);

import VueMeta from "vue-meta";
Vue.use(VueMeta);

import AsyncComputed from "vue-async-computed";
Vue.use(AsyncComputed);

Vue.config.productionTip = false;
Vue.config.errorHandler = async (error) => {
	if (
		store.getters.isLoggedIn &&
		error.response &&
		(error.response.status == 401 || error.response.status == 403)
	) {
		await store.dispatch("logout");
		router.push({
			name: "Login",
			query: {
				msg: "La sesión ha expirado",
				redirect: router.app._route.fullPath,
			},
		});
	} else {
		console.error(error);
	}
};

import axios from "axios";
window.axios = axios.create({
	headers: { Authorization: store.getters.getToken },
	params: {
		token: store.getters.getJwtEmpresa,
	},
	data: {
		token: store.getters.getJwtEmpresa,
	},
});

import JsonCSV from "vue-json-csv";
Vue.component("downloadCsv", JsonCSV);

Vue.config.productionTip = false;

const eventsHub = new Vue();
Vue.use(IdleVue, {
	eventEmitter: eventsHub,
	idleTime: 7200000,
	store,
	startAtIdle: false,
});

new Vue({
	router,
	store,
	vuetify,
	render: (h) => h(App),
	methods: {
		acceso : (value) => !!(store.getters.getPermisos[value] & Number(store.getters.getDecodedJwtEmpresa.permisos_b))
	}
}).$mount("#app");
